import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import Loader from '../../global/Loader'
import { formatDecimal } from '../../utils/helper'
// import { Container } from 'react-bootstrap'

function AmountPaid(props) {
    const { className, sectionKey, paymentData, isInfo, hideTaxIncluded, isTokenApiStarts, isExtendForm, paybleText, cardInside } = props
    // const [discountedTotal, setDiscountedTotal] = useState(0)
    // const handleDetailsDisplay = () => {
    //     setIsDisplayDetails(true)
    // }
    // useEffect(() => {
    //     const discountTotal = paymentData?.discount_amount ? paymentData?.amount_paid == 0 ? Number(paymentData?.amount_paid).toFixed(2) : (Number(paymentData?.amount_paid) - Number(paymentData?.discount_amount)).toFixed(2) : Number(paymentData?.amount_paid).toFixed(2)
    //     // setDiscountedTotal(discountTotal)
    // }, [EMPTY_ARRAY, paymentData])
    return (
        <div>
            {sectionKey == 'paymantResponse' ?
                <div className="row justify-content-between">
                    {paymentData?.amount_paid ? <>
                        <div className="col-auto">
                            <p className="mb-0 text-primary">Amount Paid</p>
                            {!hideTaxIncluded && <small> (Tax Included)</small>}
                            
                        </div>
                        <div className="col-auto text-end">
                            {isTokenApiStarts ? <Loader hideMargin size={25} color={isInfo && isExtendForm ? 'primary' : isInfo ? 'primary' : 'var(--bs-primary)'} /> 
                            : <h4 className="mb-0 fw-bold">${formatDecimal(paymentData?.amount_paid)}</h4>}
                        </div>
                    </>:
                    <Loader hideMargin size={25} color={isInfo && isExtendForm ? 'primary' : isInfo ? 'primary' : 'var(--bs-primary)'} />}
                </div>
                : cardInside ? 
                <div className="row justify-content-between">
                    <div className="col-auto">
                        <p className="mb-0 text-primary">{paybleText}</p>
                        {!hideTaxIncluded && <small> (Tax Included)</small>}
                    </div>
                    <div className="col-auto text-end">
                        <h4 className="mb-0 fw-bold">{`$${(paymentData?.payable_amount && Number(paymentData?.payable_amount) > 0) ? formatDecimal(paymentData?.payable_amount) : '0.000'}`}</h4>
                    </div>
                </div> : <div className={className}>
                    <div className='px-3'>
                        <div className={`${isInfo && isExtendForm ? 'text-primary ' : isInfo ? 'text-primary' : ' '} list-group-item d-flex justify-content-between align-items-center`}>
                            <div className="col-auto">
                                <p className="mb-0 text-primary">{paybleText}</p>
                                {!hideTaxIncluded && <small> (Tax Included)</small>}
                            </div>
                            <span className='text-end lh-1'>
                            {/* loader comment */}
                            {/* <Loader hideMargin size={20} color={isInfo && isExtendForm ? 'primary' : isInfo ? 'primary' : 'var(--bs-primary)'} /> */}
                                {isTokenApiStarts ? ''
                                 
                                : <div className="col-auto text-end">
                                    <h4 className="mb-0">
                                        {`$${(paymentData?.payable_amount && Number(paymentData?.payable_amount) > 0) ? formatDecimal(paymentData?.payable_amount) : '0.000'}`}
                                    </h4>
                                    {/* Uncomment for Displaying Info Icon */}
                                    {/* {isInfo && <i className={`fa fa-info-circle ${isExtendForm ? 'text-primary ' : 'text-white'} ms-1`} onClick={() => handleDetailsDisplay()}></i>} */}
                                </div>}
                            </span>
                        </div>
                    </div>
                </div>}
        </div>
    )
}

AmountPaid.propTypes = {
    dispatch: PropTypes.func,
    className: PropTypes.string,
    faciltyData: PropTypes.object,
    sectionKey: PropTypes.string,
    paymentData: PropTypes.object,
    isInfo: PropTypes.bool,
    setIsDisplayDetails: PropTypes.func,
    hideTaxIncluded: PropTypes.bool,
    isTokenApiStarts: PropTypes.bool,
    isExtendForm: PropTypes.bool,
    cardInside: PropTypes.bool,
    paybleText: PropTypes.string,
}

AmountPaid.defaulProps = {
    dispatch: noop,
    className: '',
    faciltyData: EMPTY_OBJECT,
    sectionKey: '',
    paybleText: '',
    paymentData: EMPTY_OBJECT,
    isInfo: false,
    setIsDisplayDetails: noop,
    hideTaxIncluded: false,
    isTokenApiStarts: false,
    isExtendForm: false,
    cardInside: false
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(AmountPaid)